import type { CreateAddressRequest } from '@nebalkon-workspace/auth';
import { LocalStorageMobileKeys } from '../../../entities/enum/local-storage-mobile-keys.enum';

/** Черновик адреса из формы заявки (гость) — синхронизируется в аккаунт после входа. */
export type PendingPickupAddressDraft = Pick<
  CreateAddressRequest,
  | 'city'
  | 'street'
  | 'building'
  | 'apartment'
  | 'entrance'
  | 'floor'
  | 'intercom'
>;

export function readPendingPickupAddress(): PendingPickupAddressDraft | null {
  try {
    const raw = localStorage.getItem(
      LocalStorageMobileKeys.PendingPickupAddressDraft,
    );
    if (!raw) {
      return null;
    }
    const json = JSON.parse(raw) as Partial<PendingPickupAddressDraft>;
    const city = typeof json.city === 'string' ? json.city.trim() : '';
    const street = typeof json.street === 'string' ? json.street.trim() : '';
    const building =
      typeof json.building === 'string' ? json.building.trim() : '';
    if (!city || !street || !building) {
      return null;
    }
    return {
      city,
      street,
      building,
      apartment: optionalString(json.apartment),
      entrance: optionalString(json.entrance),
      floor: optionalString(json.floor),
      intercom: optionalString(json.intercom),
    };
  } catch {
    return null;
  }
}

export function writePendingPickupAddress(
  draft: PendingPickupAddressDraft,
): void {
  localStorage.setItem(
    LocalStorageMobileKeys.PendingPickupAddressDraft,
    JSON.stringify(draft),
  );
}

export function clearPendingPickupAddress(): void {
  localStorage.removeItem(LocalStorageMobileKeys.PendingPickupAddressDraft);
}

function optionalString(v: unknown): string | undefined {
  if (typeof v !== 'string') {
    return undefined;
  }
  const t = v.trim();
  return t ? t : undefined;
}
